import { useEffect } from 'react';
import { ResponsiveState, useDevice } from '@atc/react-device';
import { useDispatch } from 'react-redux';
import { objectDuckCreator } from '@atc/modular-redux';

const deviceDuck = objectDuckCreator({
  store: 'browser'
});
function ReduxDeviceClient(props) {
  const device = useDevice();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(deviceDuck.creators.assign(device));
  }, [dispatch, device]);
  return props.children;
}
function setInitialReduxDeviceState(store, deviceContext) {
  // Provide initial state to redux deviceDuck for redux-responsive-shim
  if (typeof window === 'undefined') {
    const responsiveState = new ResponsiveState(deviceContext);
    const calculatedResponsiveState = responsiveState.calculate({
      initialMediaType: deviceContext.initialMediaType,
      initialOrientation: deviceContext.initialOrientation
    });

    // remove any undefined values prior to serialization
    // especially needed on getServerSideProps calls
    const deviceState = JSON.parse(JSON.stringify({
      ...deviceContext,
      ...calculatedResponsiveState
    }));
    store.dispatch(deviceDuck.creators.assign(deviceState));
  }
}

export { ReduxDeviceClient, deviceDuck, setInitialReduxDeviceState };
